import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const SouthDakota = () => {
  return (
    <StatePropertyTaxPage
      stateName="South Dakota"
      processDescription="Property owners may appeal their assessment by filing with the local board of equalization within 30 days of notification. Appeals should include evidence supporting the property owner's claimed true and full value."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in April, allowing property owners time to review their assessments before the appeal deadline."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="South Dakota assesses property as of January 1 each year. This assessment date ensures consistent property valuations across all counties in South Dakota."
      deadlineExplanation="Property owners have 30 days from notification to file appeals with the local board of equalization. This typically results in a May deadline."
    />
  );
};

export default SouthDakota;